// extracted by mini-css-extract-plugin
export var section = "letsTalkFormContainer-module--section--1XiRb";
export var wrap = "letsTalkFormContainer-module--wrap--UcImr";
export var inner = "letsTalkFormContainer-module--inner--2RAI_";
export var head = "letsTalkFormContainer-module--head--3HGg5";
export var title = "letsTalkFormContainer-module--title--2Zx1q";
export var formWrap = "letsTalkFormContainer-module--formWrap--3JBn6";
export var picWrap = "letsTalkFormContainer-module--picWrap--PC5Za";